import React, { HTMLAttributes } from 'react';
import styles from './TableContent.module.scss';

export const TableContent = (
  props: HTMLAttributes<HTMLDivElement>,
): JSX.Element => <div {...props} className={styles.Content} />;
